// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-modal-page {
  width: 100% !important;
  position: fixed;
  top: 15%;
  min-height: 330px !important;
  height: auto !important;
  background: white;
}

.sample-modal-Athletepage {
  padding: 30px;
  height: 280px;
}

.parent-buy-btn {
  background: #f93354 !important;
  width: 100%;
  height: 40px !important;
  font-size: 14px;
}

.ion-page.show-page {
  height: 40%;
}

button.parent-buy-btn.button.button-md.button-default.button-default-md:hover {
  opacity: 0.7 !important;
}

@media only screen and (max-width: 450px) {
  .sample-modal-page {
    height: 280px;
  }
  .sample-modal-Athletepage {
    height: 400px;
  }
  .parent-buy-btn {
    background: #f93354 !important;
    width: 100%;
    height: 40px !important;
  }
  button.parent-buy-btn.disable-hover.button.button-ios.button-default.button-default-ios {
    height: 40px !important;
  }
}
@media only screen and (max-width: 320px) {
  .sample-modal-Athletepage {
    height: 440px;
  }
}
.modal-wrapper {
  background-color: #ffffff;
  height: 20%;
}

.modal {
  background-color: white;
  border-radius: 3px;
}

.header {
  color: red;
  border-bottom: 1px solid #eaeaea;
}

.header p {
  margin: 0px;
}

.close-btn {
  float: right;
  --background: transparent;
  color: white;
  font-size: 17px;
  width: 40px;
  height: 30px;
}

.row label {
  float: right;
  padding-right: 15px;
  font-size: 13px;
  font-weight: bold;
}

.row input,
textarea {
  padding: 6px 12px;
  font-size: 14px;
  color: #555;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 50%;
}

.modal-wrapper {
  height: 30%;
}
.modal-wrapper .scroll-content {
  overflow: hidden;
}

.stripe-modal .modal-wrapper {
  box-shadow: 0 28px 48px rgba(0, 0, 0, 0);
  height: 250px;
}
.stripe-modal .modal-wrapper .scroll-content {
  overflow: hidden;
}

.close-btn {
  color: white;
  border-radius: 5%;
  font-size: 15px;
  white-space: pre-line;
  margin: 3px !important;
  width: 48%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.done-btn {
  color: white;
  border-radius: 5%;
  font-size: 15px;
  white-space: pre-line;
  background-color: #6c6d71 !important;
  margin: 3px !important;
  width: 48%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.tool-bar {
  background: transparent;
  --background: transparent;
  border-bottom: 1px solid #eaeaea;
}`, "",{"version":3,"sources":["webpack://./src/app/cancel-subscription-model/cancel-subscription-model.page.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,eAAA;EACA,QAAA;EACA,4BAAA;EACA,uBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,aAAA;AACJ;;AAEA;EACI,8BAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI;IACI,aAAA;EACN;EAEE;IACI,aAAA;EAAN;EAGE;IACI,8BAAA;IACA,WAAA;IACA,uBAAA;EADN;EAIE;IACI,uBAAA;EAFN;AACF;AAKA;EACI;IACI,aAAA;EAHN;AACF;AAMA;EACI,yBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,uBAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,UAAA;EACA,gCAAA;AAJJ;;AAOA;EACI,WAAA;AAJJ;;AAOA;EACI,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAJJ;;AAOA;EACI,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAJJ;;AAOA;;EAEI,iBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AAJJ;;AAOA;EACI,WAAA;AAJJ;AAMI;EACI,gBAAA;AAJR;;AAQA;EACI,wCAAA;EACA,aAAA;AALJ;AAMI;EACI,gBAAA;AAJR;;AAQA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;EACA,+GAAA;AALJ;;AAQA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,sBAAA;EACA,UAAA;EACA,+GAAA;AALJ;;AAQA;EACI,uBAAA;EACA,yBAAA;EACA,gCAAA;AALJ","sourcesContent":[".sample-modal-page {\n    width: 100% !important;\n    position: fixed;\n    top: 15%;\n    min-height: 330px !important;\n    height: auto !important;\n    background: white;\n}\n\n.sample-modal-Athletepage {\n    padding: 30px;\n    height: 280px;\n}\n\n.parent-buy-btn {\n    background: #f93354 !important;\n    width: 100%;\n    height: 40px !important;\n    font-size: 14px;\n}\n\n.ion-page.show-page {\n    height: 40%;\n}\n\nbutton.parent-buy-btn.button.button-md.button-default.button-default-md:hover {\n    opacity: 0.7 !important;\n}\n\n@media only screen and (max-width: 450px) {\n    .sample-modal-page {\n        height: 280px;\n    }\n\n    .sample-modal-Athletepage {\n        height: 400px;\n    }\n\n    .parent-buy-btn {\n        background: #f93354 !important;\n        width: 100%;\n        height: 40px !important;\n    }\n\n    button.parent-buy-btn.disable-hover.button.button-ios.button-default.button-default-ios {\n        height: 40px !important;\n    }\n}\n\n@media only screen and (max-width: 320px) {\n    .sample-modal-Athletepage {\n        height: 440px;\n    }\n}\n\n.modal-wrapper {\n    background-color: #ffffff;\n    height: 20%;\n}\n\n.modal {\n    background-color: white;\n    border-radius: 3px;\n}\n\n.header {\n    color: red;\n    border-bottom: 1px solid #eaeaea;\n}\n\n.header p {\n    margin: 0px;\n}\n\n.close-btn {\n    float: right;\n    --background: transparent;\n    color: white;\n    font-size: 17px;\n    width: 40px;\n    height: 30px;\n}\n\n.row label {\n    float: right;\n    padding-right: 15px;\n    font-size: 13px;\n    font-weight: bold;\n}\n\n.row input,\ntextarea {\n    padding: 6px 12px;\n    font-size: 14px;\n    color: #555;\n    background-color: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    width: 50%;\n}\n\n.modal-wrapper {\n    height: 30%;\n\n    .scroll-content {\n        overflow: hidden;\n    }\n}\n\n.stripe-modal .modal-wrapper {\n    box-shadow: 0 28px 48px rgba(0, 0, 0, 0);\n    height: 250px;\n    .scroll-content {\n        overflow: hidden;\n    }\n}\n\n.close-btn {\n    color:white;\n    border-radius: 5%;\n    font-size: 15px;\n    white-space: pre-line;\n    margin: 3px !important;\n    width: 48%;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n.done-btn {\n    color:white;\n    border-radius: 5%;\n    font-size: 15px;\n    white-space: pre-line;\n    background-color: #6c6d71 !important;\n    margin: 3px !important;\n    width: 48%;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\n.tool-bar {\n    background: transparent;\n    --background: transparent;\n    border-bottom: 1px solid #eaeaea;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
